export const FALLBACK_IMAGE_PATH = '/images/fallback-image.jpg';

export function handleImageError(event: Event) {
  const target = event.target as HTMLImageElement;
  if (target && !target.src.endsWith(FALLBACK_IMAGE_PATH)) {
    target.src = FALLBACK_IMAGE_PATH;
  }
}
